import { createListenerMiddleware } from '@reduxjs/toolkit';

import { reset } from '@/services/analytics';
import { storage, StorageKeys } from '@/services/storage';
import { logout } from '@/store/authActions';

export const AUTH_STORAGE_KEYS = [
  StorageKeys.TripToken,
  StorageKeys.GxToken,
  StorageKeys.TokenExpiry,
  StorageKeys.CachedToken,
  StorageKeys.Impersonator
] as const;

export const authListener = createListenerMiddleware();

authListener.startListening({
  actionCreator: logout,
  effect: () => {
    AUTH_STORAGE_KEYS.forEach(key => {
      storage.remove(key);
    });
    reset();
  }
});
